// src/index.js
import { OsanoManager } from 'appdev-ui-library';

let manager = null;
let showDrawerFn = null;

function getMetaContent(name) {
  const meta = document.querySelector(`meta[name="${name}"]`);
  return meta ? meta.content : null;
}

function isInIframe() {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

function wireButtons(selector) {
  if (!showDrawerFn) return;

  const buttons = document.querySelectorAll(selector);
  if (!buttons.length) {
    console.warn('[Osano] No elements found for selector:', selector);
    return;
  }

  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      showDrawerFn?.();
    });
  });
}

function initOsanoFromConfig() {

  if (isInIframe()) {
    console.log('[Osano] Disabled inside iframe');
    return;
  }

  // Try to get the script element that loaded this bundle
  let scriptEl = document.currentScript;

  // Fallback: first script with data-osano-url
  if (!scriptEl || !scriptEl.dataset) {
    scriptEl = document.querySelector('script[data-osano-url]');
  }

  const scriptURL =
    scriptEl?.dataset?.osanoUrl || getMetaContent('osano-script-url');

  if (!scriptURL) {
    console.error(
      '[Osano] Missing script URL. Set data-osano-url on the script tag or <meta name="osano-script-url" ...>.'
    );
    return;
  }

  const enabledAttr = scriptEl?.dataset?.osanoEnabled;
  const enabled = enabledAttr === undefined ? true : enabledAttr !== 'false';

  const country = navigator.language.split('-')[1] || 'us'
  const languageCode = navigator.language.split('-')[0] || 'en'

  const primaryColor =
    scriptEl?.dataset?.osanoPrimaryColor ||
    getMetaContent('osano-primary-color') ||
    '#333';

  const buttonSelector =
    scriptEl?.dataset?.osanoButtonSelector ||
    getMetaContent('osano-button-selector') ||
    '[data-osano-open], #cookieBtn';

  if (manager) {
    console.warn('[Osano] OsanoManager is already initialized.');
    return;
  }

  manager = new OsanoManager({
    enabled,
    scriptURL,
    country,
    languageCode,
    colorPalette: { primary: primaryColor },
    cookieBannerDefault: () =>
      console.log('[Osano] Default cookie banner removed'),
    trackingHandler: (action, payload) => {
      console.log('[Osano] Track action:', action);
      window._paq = window._paq || [];
      switch (action) {
        case 'trackClickGenericCookieBannerPolicyLink':
          _paq.push(['trackPageView', 'Click/GenericCookieBannerPolicy']);
          break
        case 'trackClickOsanoBannerCookieClickNonUs':
          _paq.push(['trackPageView', 'Click/OsanoBannerCookieClickNonUs']);
          break
        case 'trackClickGenericCookieBannerClose':
          _paq.push(['trackPageView', 'Click/GenericCookieBannerClose']);
          break
        case 'trackClickOsanoBannerCloseNonUs':
          _paq.push(['trackPageView', 'Click/OsanoBannerCloseNonUs']);
          break
        case 'trackViewGenericCookieBannerView':
          _paq.push(['trackPageView', 'Click/GenericCookieBannerView']);
          break
        case 'trackViewOsanoBannerShowNonUs':
          _paq.push(['trackPageView', 'Click/OsanoBannerShowNonUs']);
          break
        case 'trackViewOsanoViewManagePreferences':
          _paq.push(['trackPageView', 'Click/OsanoViewManagePreferences']);
          break
        case 'trackClickOsanoDrawerClose':
          _paq.push(['trackPageView', 'Click/OsanoDrawerClose']);
          break
        case 'trackClickOsanoBannerAcceptAllBtnB':
          _paq.push(['trackPageView', 'Click/OsanoBannerAcceptAllBtn']);
          break
        case 'trackClickOsanoClickManagePreferences':
          _paq.push(['trackPageView', 'Click/OsanoClickManagePreferences']);
          break
        case 'trackClickOsanoDrawerTargetAdvertising':
          _paq.push(['trackPageView', 'Click/OsanoDrawerTargetAdvertising']);
          break
        case 'trackClickOsanoDrawerPersonalization':
          _paq.push(['trackPageView', 'Click/OsanoDrawerPersonalization']);
          break
        case 'trackClickOsanoDrawerAnalytics':
          _paq.push(['trackPageView', 'Click/OsanoDrawerAnalytics']);
          break
        case 'trackClickOsanoDrawerDoNotSell':
          _paq.push(['trackPageView', 'Click/OsanoDrawerDoNotSell']);
          break
        default:
          console.warn('Unknown tracking action:', action, payload)
      }
    },
    onDrawerReady: (drawerFn) => {
      showDrawerFn = drawerFn;
      wireButtons(buttonSelector);
    },
  });

  console.log('[Osano] Initialized with scriptURL:', scriptURL);
}

function destroyOsano() {
  if (manager) {
    manager.destroy();
    manager = null;
    showDrawerFn = null;
    console.log('[Osano] Destroyed');
  }
}

// Auto-init on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initOsanoFromConfig);
} else {
  initOsanoFromConfig();
}

// Optional global API
window.OsanoApp = {
  destroy: destroyOsano,
  openPreferences: () => showDrawerFn?.(),
  getManager: () => manager,
};

